<br>
<style>
  .p-inputtext.ng-invalid.ng-touched {
    border-color: red !important;
  }

  .p-dropdown.ng-invalid.ng-touched:not(form)>div {
    border: 1px solid red;
  }
</style>
<br>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <div class="card p-shadow-21">
          <div class="card-header" style="border: none;">
            <div class="text-center font-weight-bold">
              <span class="title text-lg sign-in-line">RESET PASSWORD</span>
            </div>
          </div>
          <div class="card-body">
            <br>
            <form [formGroup]="resetPasswordForm">
              <div class="p-fluid">
                <span class="p-float-label">
                  <p-password formControlName="password" (keypress)="notAllowAmbersand($event)" toggleMask="true"></p-password>
                  <label for="Username" class="mb-1">New Password<span class="required-field">*</span></label>
                </span>
                <span class="text-danger"
                *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.errors?.required">
              </span>
              <span class="text-danger"
                *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.hasError('minlength')">
                Minimum 8 characters<br>
              </span>
              <span class="text-danger"
                *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.hasError('hasCapitalCase')">
                One uppercase<br>
              </span>
              <span class="text-danger"
                *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.hasError('hasNumber')">
                One number<br>
              </span>
              <span class="text-danger"
                *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.hasError('hasSmallCase')">
                One lowercase<br>
              </span>
              <span class="text-danger"
              *ngIf="(resetPasswordFormControl.password.touched) && resetPasswordFormControl.password.hasError('hasSpecialCharacters')">
              One special character
            </span>
              </div><br><br>
              
              <div class="p-fluid">
                <span class="p-float-label">
                  <p-password formControlName="confirmPassword" (keypress)="notAllowAmbersand($event)" toggleMask="true"></p-password>
                  <label for="Username" class="mb-1">Re-enter New Password<span class="required-field">*</span></label>
                </span>
                <span class="text-danger"
                *ngIf="(resetPasswordFormControl.confirmPassword.touched) && resetPasswordFormControl.confirmPassword.errors?.required">
              </span>
              <span class="text-danger"
                *ngIf="(resetPasswordFormControl.confirmPassword.touched) && resetPasswordFormControl.confirmPassword.errors?.confirmPasswordValidator">
                Password doesn't match
              </span>
              </div><br>
             <br>
              <div class="p-fluid mx-auto">
                <button pButton type="button" [disabled]="!resetPasswordForm.valid" (click)="resetPassword(resetPasswordForm)" label="Change Password"
                  class="btn-login"></button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4"></div>
    </div>
  </div>
</div>
<p-toast position="bottom-center"></p-toast>
